(function () {
  function init(container) {
    var section = container || document.querySelector('.oddit-section-whats-inside');
    if (!section) return;
    var track = section.querySelector('.oddit-section-whats-inside__grid');
    var cards = section.querySelectorAll('.oddit-section-whats-inside__card');
    var dots = section.querySelectorAll('.oddit-section-whats-inside__dot');
    if (!track || !cards.length || !dots.length) return;

    var mql = window.matchMedia('(min-width: 750px)');
    var io = null;

    function setActive(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('oddit-section-whats-inside__dot--active', i === index);
      });
    }

    function enable() {
      if (io) return;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = Array.prototype.indexOf.call(cards, entry.target);
          if (index >= 0) setActive(index);
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (c) { io.observe(c); });
    }

    function disable() {
      if (!io) return;
      io.disconnect();
      io = null;
    }

    function sync() {
      if (mql.matches) disable();
      else enable();
    }

    function destroy() {
      disable();
      mql.removeEventListener('change', sync);
    }

    sync();
    mql.addEventListener('change', sync);

    section._odditWhatsInsideDestroy = destroy;
  }

  init();

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('.oddit-section-whats-inside');
    if (container) init(container);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var container = e.target.querySelector('.oddit-section-whats-inside');
    if (container && container._odditWhatsInsideDestroy) {
      container._odditWhatsInsideDestroy();
    }
  });
})();
